import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  reports: [],
  current_report: false,
  // UPLOAD REPORTS
  pullFiles: [],
  uploading: false
};

// getters
const getters = {
  getReports: (state, getters, rootState) => {
    return state.reports;
  },

  getCurrentReport: (state, getters, rootState) => {
    return state.current_report;
  },

  getUploadsLength: (state, getter, rootState) => {
    var n = 0;
    if (state.uploading) n++;

    return n + state.pullFiles.length;
  },

  getUploading: state => {
    return state.uploading;
  }
};

// actions
const actions = {
  loadReports({ commit }) {
    return api.get("partner/report").then(function(response) {
      if (response.status) {
        var data = response.data;

        return commit("setReports", data);
      }
    });
  },

  loadReportsUser({ commit }, idUser) {
    return api.get("report/user/" + idUser).then(function(response) {
      if (response.status) {
        var data = response.data;

        return commit("setReports", data);
      }
    });
  },

  loadReportsRestaurant({ commit }, idUser) {
    return api.get("report/restaurant/" + idUser).then(function(response) {
      if (response.status) {
        var data = response.data;

        return commit("setReports", data);
      }
    });
  },

  uploadReport: ({ commit, dispatch }, aData) => {
    var formData = new FormData();
    formData.append("report", JSON.stringify(aData.report));
    formData.append("file", aData.file);

    return api.upload("partner/report/add", formData).then(function(response) {
      return response;
    });
  },

  uploadPdf: ({ commit, dispatch }, aData) => {
    var formData = new FormData();
    formData.append("pdf", JSON.stringify(aData.pdf));
    formData.append("file", aData.file);

    return api
      .upload("partner/report/addpdf", formData)
      .then(function(response) {
        return response;
      });
  },

  deleteReport({ commit }, oReport) {
    return api
      .post("partner/report/delete", { report: JSON.stringify(oReport) })
      .then(function(response) {
        return response;
      });
  },

  deleteAllReport({ commit }, date) {
    return api
      .get("partner/report/" + date + "/delete")
      .then(function(response) {
        return response;
      });
  }
};

// mutations
const mutations = {
  setReports(state, reports) {
    state.reports = reports;
  },

  setCurrentReport(state, report) {
    state.current_report = report;
  },

  setCurrentReportByDate(state, date) {
    state.current_report = state.reports[date];
  },

  addReport(state, report) {
    var reports = state.reports;

    reports[report.id] = report;

    state.reports = { ...reports };
  },

  addFileToUpload(state, file) {
    var files = state.pullFiles;

    files.push(file);

    state.pullFiles = files;
  },

  setPullFiles(state, pull) {
    state.pullFiles = pull;
  },

  setUploading(state, upload) {
    state.uploading = upload;
  },

  updateUpload(state, update) {
    var uploading = { ...state.uploading };

    uploading[update.param] = update.value;
    state.uploading = uploading;
  }

  //   addReport(state, report) {
  //     var reports = { ...state.reports };
  //     reports[report.id] = report;

  //     state.reports = reports;
  //   },

  //   removeReport(state, id) {
  //     var reports = { ...state.reports };
  //     delete reports[id];

  //     state.reports = reports;
  //   }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
